<template>
  <div class="bigbox">
    <van-cell-group>
      <van-cell title="查询结果" :value="selectBirthDate"/>
      <van-cell title="增值税金额" :value="vatamount"/>
    </van-cell-group>
    <van-cell-group title="增值税子类别">
      <van-cell title="进项税额" :value="Xiaoamount"/>
      <van-cell title="销项税额" :value="Jingamount"/>
      <van-cell title="出口退税" :value="ChuKouamount"/>
    </van-cell-group>
    <van-cell-group title="列表明细">
      <van-cell v-for="(item,i) in TaxList" :key="i" :title="item.AffirmDate" :label="item.State">
        <van-row>
          <van-col :span="12">
            <span>{{item.TaxName}}</span>
            <i>{{item.TaxAmount}}</i>
          </van-col>
          <van-col :span="12">
            <van-button type="primary" size="mini" v-show="item.State=='未结转'" @click="fow(item)">结转</van-button>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
    <div class="mt10">
      <van-button type="primary" size="small" block @click="Clickforward()">结转</van-button>
    </div>
  </div>
</template>

<script>
  import {
    getTaxDetailApi,
    getDetailLastOneTaxListApi,
    getTaxReportIsendsApi,
    jieZhuanDetailApi,
    getTaxReportIsendApi
  } from '@/api/tax'

  export default {
    name: "VATquery",
    data() {
      return {
        selectBirthDate: '',
        TaxList: [],
        vatamount: '',
        Xiaoamount: '',
        Jingamount: '',
        ChuKouamount: ''
      }
    },
    mounted() {
      this.GetDetailTaxList()
      this.GetTaxReportIsends()
      this.GetDetailLastOneTaxList()
      this.GetTaxReportIsend()
    },
    methods: {
      async fow(record) {
        const params = {
          C_GUID: sessionStorage.getItem('companyId'),
          GUID: record.GUID,
          Amount: record.TaxAmount,
          TaxAmount: record.TaxAmount,
          Name: '应交税费',
          TaxName: record.TaxName,
          Date: record.Date
        }
        const response = await jieZhuanDetailApi(params);
        if (response.success) {
          this.GetDetailTaxList()
        }
      },
      JieZhuanDetail(i) {
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/JieZhuanDetail',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
            GUID: sessionStorage.getItem('GUID'),
            Amount: sessionStorage.getItem('TaxAmount'),
            TaxAmount: sessionStorage.getItem('TaxAmount'),
            Name: '应交税费',
            TaxName: sessionStorage.getItem('TaxName'),
            Date: sessionStorage.getItem('AffirmDate')
          })
        }).then(res => {
          console.log(sessionStorage.getItem('TaxName'))
          window.location.reload()
        })
      },
      async GetDetailTaxList() {
        const params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          AffirmDate: this.$route.query.d,
          period: 'month'
        };
        let response = await getTaxDetailApi(params);
        if (response.success) {
          var btn = document.getElementById('btncon')
          this.TaxList = response.result
          for (var i = 0; i < this.TaxList.length; i++) {
            if (this.TaxList[i].State === '未结转') {
              btn.style.display = 'block'
            } else {
              btn.style.display = 'none'
            }
          }
        }
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/GetDetailTaxList',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
            AffirmDate: sessionStorage.getItem('vatdate'),
            period: 'month'
          })
        }).then(res => {
          var btn = document.getElementById('btncon')
          this.TaxList = res.data.result
          for (var i = 0; i < this.TaxList.length; i++) {
            if (this.TaxList[i].State === '未结转') {
              btn.style.display = 'block'
            } else {
              btn.style.display = 'none'
            }
          }

        })
      },
      async GetTaxReportIsends() {
        let params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          reportDate: this.$route.query.d,
          period: 'month',
          isend: '0',
        };
        const response = await getTaxReportIsendsApi(params);
        if (response.success) {
          this.vatamount = JSON.stringify(response.result[0].XiaoAmount)
          this.Xiaoamount = JSON.stringify(response.result[0].XiaoAmount)
          this.Jingamount = JSON.stringify(response.result[0].JingAmount)
          this.ChuKouamount = JSON.stringify(response.result[0].ChuKouAmount)
        }
      },
      async GetDetailLastOneTaxList() {
        const params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          AffirmDate: this.$route.query.d,
          period: 'month'
        };
        let response = await getDetailLastOneTaxListApi(params);
        if (response.success) {
          this.selectBirthDate = response.result[0].AffirmDate
        }
      },
      async GetTaxReportIsend() {
        const params = {
          C_GUID: this.getCookie("CompanyInfo").companyId,
          AffirmDate: this.$route.query.d,
          period: 'month',
          isend: '1',
        };
        let response = await getTaxReportIsendApi(params);
        if (response.success) {
          console.log("send",response);
          this.selectBirthDate = response.result[0].AffirmDate
        }
        // this.$axios({
        //   method: 'post',
        //   url: '/fmsapi/TaxProvisionRecord/GetTaxReportIsend',
        //   data: this.$qs.stringify({
        //     C_GUID: sessionStorage.getItem('companyId'),
        //     reportDate: sessionStorage.getItem('vatdate'),
        //     period: 'month',
        //     isend: '1',
        //   })
        // }).then(res => {
        //   sessionStorage.setItem('vatamount', JSON.stringify(res.data.result[0].XiaoAmount))
        //   sessionStorage.setItem('Jingamount', JSON.stringify(res.data.result[0].JingAmount))
        //   sessionStorage.setItem('ChuKouamount', JSON.stringify(res.data.result[0].ChuKouAmount))
        //   sessionStorage.setItem('ChuNeiAmount', JSON.stringify(res.data.result[0].ChuNeiAmount))
        //   sessionStorage.setItem('XiaoChuAmount', JSON.stringify(res.data.result[0].XiaoChuAmount))
        //   console.log(res.data.result[0])
        // })
      },
      Clickforward() {
        this.$axios({
          method: 'post',
          url: '/fmsapi/TaxProvisionRecord/AddTaxProvisionRecord',
          data: this.$qs.stringify({
            C_GUID: sessionStorage.getItem('companyId'),
            Amount: sessionStorage.getItem('vatamount'),
            Date: sessionStorage.getItem('selectBirthDate'),
            inputtax: sessionStorage.getItem('Jingamount'),
            outputtax: sessionStorage.getItem('vatamount'),
            exportreduce: sessionStorage.getItem('ChuNeiAmount'),
            transfertax: sessionStorage.getItem('XiaoChuAmount'),
            exporttax: sessionStorage.getItem('ChuKouamount'),
          })
        }).then(res => {
          console.log(res.data)
          location.reload()
        })
      }
    }
  }
</script>

<style scoped>
  html, body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  /*大盒子，首位固定*/
  .bigbox {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;

  }

  /*头部固定*/
  header {
    height: 3.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff
  }

  /*头部标题*/
  .head {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1.3rem;
    color: black;
  }

  /*标题样式*/
  .head h2 {
    display: block;
    width: 25rem;
    text-align: center;
  }

  .head img:last-child {
    width: 1.5rem;
    height: 1.1rem;
  }

  .head img:first-child {
    width: 0.9rem;
    height: 1.7rem;
  }

  section {
    flex: 1;
    overflow: auto;
  }

  #fow {
    color: #2626fd;
    font-size: 1.3rem;
    margin-right: 1.2rem;
    margin-top: 1.3rem;
  }

  .Topmain {
    height: 10.5rem;
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
  }

  .Topmain a {
    display: block;
    width: 10.7rem;
    height: 3.3rem;
    background: white;
    border-radius: 8px;
    color: black;
    text-align: center;
    line-height: 3.2rem;
    margin-left: 10px;
  }

  .Topmain a:first-child {
    background: #09a9bf;
    color: white
  }

  .maincon {
    width: 100%;
  }

  .Centermain {
    /*height: 2rem;*/
    background: #ffffff;
  }

  .inCon1 {
    height: 2.8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .inCon1 p {
    width: 12rem;
    height: 100%;
    line-height: 2.8rem;
    font-size: 1.3rem;
    color: black;
  }

  .inCon1 input {
    display: block;
    width: 13.7rem;
    height: 2.8rem;
    font-size: 1.3rem;
    text-align: right;
  }

  .topcon, .topcon1 {
    height: 4.6rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.9rem;

  }

  .topcon1 {
    height: 3rem;
  }

  .topcon h2 {
    height: 100%;
    line-height: 4.6rem;
    font-size: 1.5rem;
    color: #09a9bf;
  }

  .topcon1 h2 {
    color: black;
    height: 100%;
    line-height: 3rem;
    font-size: 1.3rem;
  }

  .topcon input, .topcon1 input {
    display: block;
    width: 13.7rem;
    height: 4.6rem;
    font-size: 1.4rem;
    text-align: right;
  }

  .topcon1 input {
    font-size: 1.3rem;
  }

  .botcon {
    height: 9.6rem;
    margin-top: 1rem;
    padding: 0 1.9rem;
  }

  .botcon h2 {
    line-height: 3rem;
    font-size: 1.5rem;
    color: #09a9bf;
  }

  .Centermain1 {
    /*padding: 0 19rem*/
  }

  .Centermain1 li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 5.9rem;
    color: black;
    border-bottom: 1px solid #d8d8d8;
  }

  .con {
    height: 5rem;
    color: #09a9bf;
    font-size: 0.14rem;
    line-height: 5.4rem;
    border-bottom: 1px solid #d8d8d8
  }

  .icon1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .iconleft {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .iconleft span {
    font-size: 0.9rem;
    color: #979797;
  }

  .iconleft i {
    font-size: 1.4rem;
    color: black;
  }

  .iconright {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .iconright1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 8rem;
  }

  .iconright1 span {
    font-size: 1rem;
    color: #979797;
  }

  .iconright1 i {
    font-size: 1.3rem;

  }

  .iconright a img {
    width: 1.5rem;
    height: 1.4rem;
  }

  footer {
    display: flex;
    padding: 1rem 0;
    background: white;
    justify-items: center;
    align-items: center;
  }

  .btn {
    margin: 0 auto;
    width: 25rem;
    height: 3.5rem;
    background: #379ce2;
    font-size: 1.4rem;
    text-align: center;
    line-height: 3.5rem;
    border-radius: 20px;
  }

  #btncon {
    margin: 0 auto;
    width: 25rem;
    height: 3.5rem;
    background: #379ce2;
    font-size: 1.4rem;
    text-align: center;
    line-height: 3.5rem;
    border-radius: 20px;
  }
</style>
